import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/_services/utility.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-il-mio-team',
  templateUrl: './il-mio-team.component.html',
  styleUrls: ['./il-mio-team.component.css']
})
export class IlMioTeamComponent implements OnInit {
  current_month: any = '';
  current_year: any = '';
  users: any = [];

  isMobile: boolean = false;
  isDesktop: boolean = false;
  isTablet: boolean = false;

  start_date_week: any;
  end_date_week: any;

  constructor(
    private readonly titleService: UtilityService,
    private readonly title: Title
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Progetti');
    this.title.setTitle('Progetti | Sviluppo Personale');

    const screenWidth = window.innerWidth;

    if (screenWidth <= 567) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.isDesktop = true;
    }
  }

  public get_year($event: any): void {
    this.current_year = $event;
    // this.getAllData()
  }

  public get_month($event: any): void {
    this.current_month = $event;
    // this.getAllData()
  }

  public get_start_week($event: any): void {
    this.start_date_week = $event;
  }

  public get_end_week($event: any): void {
    this.end_date_week = $event;
    // this.getAllData();
  }
}
